export const getViteEnv = (): Record<string, string | undefined> => {
  try {
    return import.meta.env as Record<string, string | undefined>;
  } catch {
    // If import.meta is unavailable, use the test shim on process.env.
  }

  if (typeof process !== 'undefined' && typeof process.env !== 'undefined') {
    return process.env as Record<string, string | undefined>;
  }

  return {};
};
